import { SearchField } from "containers/ExecutionFilter/interfaces";
import { getFilterFieldsList, getFilterString } from "utils/utils";
import { baseExecutionFilter } from "./constants";

/**
 * Query-param fragment that seeds the execution list filter of a dashboard
 * "Show all" link. The executions screen imports URL filter params into its
 * stored (localStorage) filter on open, so the list shows exactly what the
 * widget counts: all executions (children included, so `no_parent_id` is off)
 * plus any widget-specific fields, e.g. `is_productive`.
 */
export const getDashboardExecutionFilterParams = (...filterFields: SearchField[]) =>
    `filter=${encodeURIComponent(
        getFilterString(getFilterFieldsList(...filterFields, ...baseExecutionFilter))
    )}`;
